<template>
    <div class="footer">
        <!-- prev -->
        <button type="button" class="btn btn--prev" v-bind:class="{ 'disabled' : isFirstPage }"
                v-on-single-click="prev">
            <img class="icon" src="../assets/img/arrow-prev.svg" alt="">
            <span class="help-text help-text--prev">
                <apng v-bind:apng="require('../assets/img/zurueck_handschrift_anim.png')"
                      v-bind:png="require('../assets/img/zurueck_handschrift_01.png')" alt=""/>
            </span>
        </button>
        <!-- dots -->
        <div class="dots">
            <div class="dots-inner">
                <div v-for="(page, index) in pages" :key="index" class="dot" v-bind:style="dotLeftCalculated"
                     v-bind:class="{ 'current-prev': Math.abs(index - currentPage) < 2, 'current': index === currentPage }">
                    {{ index + 1 }}
                </div>
            </div>
            <span class="help-text help-text--timeline">
                <apng v-bind:apng="require('../assets/img/timeline_handschrift_anim.png')"
                      v-bind:png="require('../assets/img/timeline_handschrift_01.png')" alt=""/>
            </span>
        </div>
        <!-- next -->
        <button type="button" class="btn btn--next" v-bind:class="{ 'disabled' : isLastPage }" v-on-single-click="next">
            <img class="icon" src="../assets/img/arrow-next.svg" alt="">
            <span class="help-text help-text--next">
                <apng v-bind:apng="require('../assets/img/weiter_handschrift_anim.png')"
                      v-bind:png="require('../assets/img/weiter_handschrift_01.png')" alt=""/>
            </span>
        </button>
    </div>
</template>


<script>
    export default {
        name: "Footer",
        data: function ()
        {
            return {
                currentPage: 0,
                // dotWidth: parseInt(window.getComputedStyle(document.querySelector('.dot')).width), 
                dotWidth: (3 * 0.31146),
            }
        },
        watch: {
            '$route'()
            {
                this.init();
            }
        },
        computed: {
            pages: function ()
            {
                return this.$router.options.routes;
            },
            isFirstPage: function ()
            {
                return this.currentPage === 0;
            },
            isLastPage: function ()
            {
                return this.currentPage === (this.$router.options.routes.length - 1);
            },
            dotLeftCalculated: function ()
            {
                let a = this.currentPage + 1;
                a = (a < 4) ? 4 : a;
                a = (a > this.pages.length - 3) ? (this.pages.length - 3) : a;
                let b = 1 + this.pages.length - a;
                let c = (b - a) / 2;
                let d = c * this.dotWidth;
                let e = d + 'rem';
                return {
                    left: e,
                };
            }
        },
        created()
        {
            this.$eventBus.$on('nextPage', () =>
            {
                this.currentPage = Math.min(this.currentPage + 1, this.$router.options.routes.length - 1);
                this.$router.push(this.$router.options.routes[this.currentPage].path);

                // currentPage
                this.$eventBus.$emit('currentPage', this.$data.currentPage);
            });

            this.$eventBus.$on('prevPage', () =>
            {
                this.currentPage = Math.max(this.currentPage - 1, 0);
                this.$router.push(this.$router.options.routes[this.currentPage].path);

                // currentPage
                this.$eventBus.$emit('currentPage', this.$data.currentPage);
            });
        },
        mounted()
        {
            this.init();
        },
        methods: {
            init: function ()
            {
                // Aktuelle Seite aus Route übernehmen (this.$route.path geht für dynamische geladene Seiten nicht)
                if (window.location.hash !== '#/')
                {
                    for (let i = 0; i < this.$router.options.routes.length; i++)
                    {
                        if ('#' + this.$router.options.routes[i].path === window.location.hash)
                        {
                            this.currentPage = i;
                        }
                    }
                }

                // Page Tracking
                this.$tracking.page(this.$router.options.routes[this.currentPage]);

                // currentPage
                this.$eventBus.$emit('currentPage', this.$data.currentPage);
            },
            next: function ()
            {
                this.$tracking.navigationClick('Seite vor');
                this.$eventBus.$emit('nextPage');
            },
            prev: function ()
            {
                this.$tracking.navigationClick('Seite zurück');
                this.$eventBus.$emit('prevPage');
            },
        }
    };
</script>

<style lang="scss">

</style>
